import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";
export type RewardfulConvertArgs = { email: string } & Record<string, unknown>;

type RewardfulFn = (event: string, payload?: Record<string, unknown>) => void;

export const getRewardful = (): RewardfulFn | null => {
  if (typeof window === "undefined") return null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rf = (window as any).rewardful;
  return typeof rf === "function" ? (rf as RewardfulFn) : null;
};

export const rewardfulIsAvailable = (): boolean => getRewardful() != null;

export const rewardfulConvert = (args: RewardfulConvertArgs): void => {
  const rf = getRewardful();
  if (!rf) return;
  rf("convert", args);
};

export const trackConversionWithRewardful = (args: RewardfulConvertArgs): void => {
  try {
    rewardfulConvert(args);
  } catch (unknownErr) {
    logger.error({
      message: "[Rewardful] convert failed",
      info: {
        error: objectModule.safeErrorAsJson(unknownErr as Error),
        args: objectModule.safeAsJson(args),
      },
    });
  }
};
